import api from "../../../api";
import React from "react";
import utils from "../../../utils";
import values from "../../../values";
import Context from "../../../context";
import GovernmentShipScreen from "..";

import { TModal } from "../../../types/common.type";
import { useQuery } from "react-query";
import { DeleteModal } from "../../../components";
import { IFindUserInformation } from "../../../types/common.interface";
import { ICreateAndUpdateGovernmentShip } from "../../../types/govenmentShip.interface";

const GovernmentShipContainer = () => {
  // ** ====================================================================================================================
  // ** --------------------------------------------------------------------------------------------------------------------
  // **                                               Value Validations
  // ** --------------------------------------------------------------------------------------------------------------------

  const [showModal, setShowModal] = React.useState<TModal>("NONE");
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [selectedGovernmentShip, setSelectedGovernmentShip] =
    React.useState<any>();
  const [requestGovernmentShip, setRequestGovernmentShip] =
    React.useState<IFindUserInformation>({
      page: 1,
      limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
      search: { base: "", value: "" },
      filters: {
        province: undefined,
        city: undefined,
      },
    });
  // ** --------------------------------------------------------------------------------------------------------------------
  // ** ====================================================================================================================

  // !! ====================================================================================================================
  // !! --------------------------------------------------------------------------------------------------------------------
  // !!                                                Start API Cal
  // !! --------------------------------------------------------------------------------------------------------------------

  // const resultGovernmentShip = { data: { result: { docs: [] } } };

  const resultGovernmentShip = useQuery(
    [
      values.useQueryKeys.getAllGovernmentShip,
      requestGovernmentShip?.page,
      requestGovernmentShip?.search?.value,
      requestGovernmentShip?.filters,
    ],
    () =>
      api.post.administrator.getAllGovernmentShip({
        filters: requestGovernmentShip?.filters,
        search: requestGovernmentShip?.search,
        limit: requestGovernmentShip?.limit,
        page: requestGovernmentShip?.page,
      })
  );

  // !! --------------------------------------------------------------------------------------------------------------------
  // !! ====================================================================================================================

  // ** ====================================================================================================================
  // ** --------------------------------------------------------------------------------------------------------------------
  // **                                               Local Functions
  // ** --------------------------------------------------------------------------------------------------------------------
  async function createFunction(formData: ICreateAndUpdateGovernmentShip) {
    setIsLoading(true);
    const result = await api.post.administrator.createGovernmentShip(formData);
    if (result) {
      utils.successHandler(Number(2010)); // result.CODE === 2021
      // resultGovernmentShip.refetch();
      setShowModal("NONE");
      setIsLoading(false);
      return true;
    }
    setIsLoading(false);
    return false;
  }
  async function updateFunction(formData: ICreateAndUpdateGovernmentShip) {
    setIsLoading(true);
    const result = await api.put.administrator.updateGovernmentShip(formData);
    if (result) {
      utils.successHandler(Number(2010)); // result.CODE === 2021
      resultGovernmentShip.refetch();
      setShowModal("NONE");
      setIsLoading(false);
      return true;
    }
    setIsLoading(false);
    return false;
  }
  async function deleteFunction(userId: string) {
    setIsLoading(true);
    // const result = await api.dele.administrator.deleteGovernmentShip(userId);
    // if (result) {
    //   utils.successHandler(Number(2010)); // result.CODE === 2021
    //   // resultGovernmentShip.refetch();
    //   setShowModal("NONE");
    // }
    setIsLoading(false);
    return false;
  }
  // ** --------------------------------------------------------------------------------------------------------------------
  // ** ====================================================================================================================

  // ?? ====================================================================================================================
  // ?? --------------------------------------------------------------------------------------------------------------------
  // ??                                                JSX Container
  // ?? --------------------------------------------------------------------------------------------------------------------
  return (
    <Context.GovernmentShipScreen.Provider
      value={{
        showModal,
        isLoading,
        setShowModal,
        setIsLoading,
        updateFunction,
        createFunction,
        requestGovernmentShip,
        selectedGovernmentShip,
        setRequestGovernmentShip,
        setSelectedGovernmentShip,
      }}
    >
      <GovernmentShipScreen rqGovernmentShip={resultGovernmentShip} />
      <DeleteModal
        open={showModal === "DELETE"}
        user={selectedGovernmentShip}
        data={selectedGovernmentShip}
        loading={isLoading}
        onClose={() => setShowModal("NONE")}
        onSubmit={deleteFunction}
      />
    </Context.GovernmentShipScreen.Provider>
  );

  // ?? --------------------------------------------------------------------------------------------------------------------
  // ?? ====================================================================================================================
};

export default GovernmentShipContainer;
